import { http } from '@/utils/request.js'

export function regAPI(data) {
  return http({
    url: '/api/reg',
    method: 'post',
    data
  })
}
export function loginPI(data) {
  return http({
    url: '/api/login',
    method: 'post',
    data
  })
}
/**
 * 用户信息
 * @returns
 */
export function getUserInfoAPI() {
  return http({
    url: '/my/userinfo',
    method: 'get'
  })
}
export function getMenuListAPI() {
  return http({
    url: '/my/menus',
    method: 'get'
  })
}
